import axios from "axios";
import { Component } from "vue/types/umd";
import {
  openDialog,
  showDialogContent,
  showLoading,
} from "../pages/form-buttons-controls-rest";
import Vue from "@app/js/modules/vueApp";

class UI {
  private vueComponents?: Record<string, Component>;
  private hasVueComponents = false;

  components(components: Record<string, Component>): this {
    this.hasVueComponents = true;
    this.vueComponents = components;
    return this;
  }

  private setupVue() {
    if (this.hasVueComponents && document.getElementById("dialog-vue-app")) {
      console.debug("Setting up vue...");
      new Vue({
        components: this.vueComponents,
        name: "AppDialog",
      }).$mount("#dialog-vue-app");
    }
  }

  async edit(url: string, item: { id: number }): Promise<void> {
    this.openDialog(axios.post(url, { id: item.id }), "data");
  }

  async create(url: string, data: Record<string, unknown> = {}): Promise<void> {
    this.openDialog(axios.post(url, data), "data");
  }

  private showContent(content: string) {
    showDialogContent(content);
    this.setupVue();
  }

  openDialog(content: string | Promise<string>, attribute?: string) {
    openDialog();

    if (typeof content === "string") {
      this.showContent(content);
    } else {
      showLoading();
      content.then((response) => {
        const content = attribute ? response[attribute] : response;
        this.showContent(content);
      });
    }
  }
}

export default new UI();
